import React, { useContext } from "react";
import PropTypes from "prop-types";

import { Marker as MapMarker } from "react-leaflet";
import { pinDiv } from "./Icon";
import MapContext from "../context/MapContext";

// Marker is the pin we see on the map
// Markers handles the conditional logic on which pins to show
// This Marker component is what is rendered
// each pin needs several event handlers based on click, hover and menu interaction
// lots of conditional logic on whether the pin should be highlighted

const NewFoodMarker = (props) => {
	const { location, index, position } = props;

	const {
		data: {
			selectedCategory,
			highlightedPin,
			highlightedMenuItem,
			selectedLocation,
			showPopout,
			highlightedLocation,
		},
		actions: { handleHoverPin, handleCategory },
	} = useContext(MapContext);

	// event handlers
	const handleClick = () => {
		handleCategory(location.category);
	};
	const handleHoverOver = () => {
		handleHoverPin(location, index);
	};
	const handleHoverOut = () => {
		handleHoverPin();
	};

	const events = {
		click: handleClick,
		mouseover: handleHoverOver,
		mouseout: handleHoverOut,
	};
	// conditional logic for highlighting a pin
	const displayNumber = Number.isInteger(+location.display);
	const displayIcon = displayNumber ? location.display : null;

	// pin and menu-item should be highlighted because user has hovered over that location in the menu
	const isHighlightedFromMenu =
		highlightedMenuItem &&
		highlightedMenuItem === location.category &&
		highlightedPin.index === "all";

	// pin and menu-item should be highlighted because user has hovered over that pin
	const isHighlightedFromPin =
		highlightedPin &&
		highlightedPin.name === location.category &&
		highlightedPin.index === index;

	// pin and menu-item should be highlighted because user has selected that location
	// pin will remain highlighted if they close the popout panel
	const isHighlightedFromSelectedLocation =
		showPopout &&
		selectedLocation.category &&
		selectedLocation.category === location.category;

	// specific icons provided for midway, food-truck, and food-building
	// otherwise use generic-map-icon	
	let pinIcon = location.category === "midway" || location.category === "food-truck" || location.category === "food-building" ? location.category : "new-food-generic";
	
	const classes = `pin-icon ${
		isHighlightedFromMenu ||
		isHighlightedFromPin ||
		isHighlightedFromSelectedLocation ||
		highlightedLocation === location.category ||
		selectedCategory === location.category
			? "highlight"
			: ""
	} ${"icon-" + pinIcon}`;

	return (
		<MapMarker
			key={`${location.name}-${index}`}
			eventHandlers={{ ...events }}
			interactive={true}
			// icon needs two args
			// what shows up on the pin and the classes
			icon={pinDiv(displayIcon, classes)}
			position={[...position]}
		></MapMarker>
	);
};

NewFoodMarker.propTypes = {
	location: PropTypes.object,
	index: PropTypes.number,
	position: PropTypes.array,
};

export default NewFoodMarker;
